
document.addEventListener('DOMContentLoaded' , function() {

  //MENU TOGGLE
  if (window.screen.width < 900) {
    // ----- MENU -----
    var menu = document.querySelector('.header_middle_left .show_menu');
    menu.addEventListener('click', toggleMenu);
    function toggleMenu() {
      var menuForm = document.querySelector('#nav_toggle');
      if (menuForm.style.display === "block") {
        menuForm.style.display = "none"

      } else {
        menuForm.style.display = "block"
      }
    }
    // ----- END OF MENU -----
    // ----- SUB_MENU -----
    var arrowIcon = document.querySelectorAll('.submenu_mobile_icn');
    arrowIcon.forEach(function (i) {
      i.addEventListener('click', toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.parentNode.children[2].style.display === "block") {
          this.parentNode.children[2].style.display = "none";
        } else {
          this.parentNode.children[2].style.display = "block";
        }
      }
    })
    // ----- END OF SUB_MENU -----
  }

  //----------TOP NEWS SLIDER---------
  const topnewsSlider = document.getElementById('topnews_slider');
  if (topnewsSlider) {
    new Splide( '#topnews_slider', {
      direction:'rtl',
      type: 'loop'
    } ).mount();
  }

  //-------SEARCH TOGGLE-----
  var slideOpen = true;
  if (window.screen.width < 900) {

    document.querySelector('#click_to_search').addEventListener('click' , function() {
      var searchForm = document.querySelector('.search_box form');
      if(slideOpen) {
          slideOpen = false;
          searchForm.style.height = '30px';
      }
      else {
          slideOpen = true;
          searchForm.style.height ='0px';
      }
    })
  }

   // ---------------------TAB BOX -------------------------
    var tabHeader = document.querySelectorAll(
    ".multi_tab .tabs li"
    );
    tabHeader.forEach(function (item) {
      item.addEventListener("click", function (e) {
      if (!item.classList.contains("active")) {
          // find index of clicked item
          var tabNum = Array.prototype.indexOf.call(tabHeader, item);
          var nthChild = tabNum + 1;
          // remove active class from all items
          tabHeader.forEach(function (item) {
          item.classList.remove("active");
          });
          // add active class to clicked item
          item.classList.add("active");
          // remove active class from all tab content
          var tabContent = document.querySelectorAll(
          ".tab_content .tab_cont"
          );
          tabContent.forEach(function (item) {
          item.classList.remove("active");
          item.classList.remove("visible");
        });
        // add active class to tab content
        document
        .querySelector(".tab_content .tab_cont:nth-child(" + nthChild + ") ")
        .classList.add("active");
        document
        .querySelector(".tab_content .tab_cont:nth-child(" + nthChild + ") ")
        .classList.add("visible");
    }
        });
    });

  // -------------STICKY NEWS -----------------
  if (document.getElementById("emergency")) {
      const mySticky = document.getElementById("emergencyyy");
      window.onscroll = function() {scrollFunction()};
      function scrollFunction() {
          if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
              mySticky.classList.add("fixed_emergency_news");
          } else {
              mySticky.classList.remove("fixed_emergency_news");
          }
      }
      document.getElementById("emergency-close").addEventListener("click", function () {
          const emergencyBox = document.getElementById("emergencyyy");
          const display = window.getComputedStyle(emergency).display;
          if (display === "none") {
          emergencyBox.style.display = "block";
          } else {
          emergencyBox.style.display = "none";
          }
      });
  }

  //---- TOP NEWS MULTI ----
    if (document.getElementById('top_news_multi')) {
      new Splide('#top_news_multi', {
        autoplay: false,
        interval: 4000,
        type: 'loop',
        direction: 'rtl',
        adaptiveHeight: true,
      }).mount();
    }
    // -----ALBUM LIGHTGALLERY-----
    if (document.querySelectorAll('#new_gallery')) {
      var gallery = document.querySelectorAll("#lightgallery");
      gallery.forEach(function (pic) {
        lightGallery(pic, {
          speed: 500,
          plugins: [lgThumbnail],
          thumbnail: true

        });
      });
    }
    //----------STICKY ADV --------------
    if (document.querySelector(".position-c9")) {
      zxc_j9 = true;
      window.addEventListener('scroll', function () {
        if (window.pageYOffset > 250 && zxc_j9) {
          document.querySelector(".sticky_zxc_top").classList.replace("position_c9", "mobile_visible_fixed");
        }
      });
      document.querySelector("#close_adv").addEventListener('click', function () {
        document.querySelector(".sticky_zxc_top").classList.replace("mobile_visible_fixed", "position_c9");
        zxc_j9 = false;
      })
    }
  //----------STICKY ADV --------------
  
  // *.*.*.*.*.*.*.*.*.*.* archive toggle *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
  if (document.getElementsByClassName("flip").length > 0) {
    var control_flip = document.querySelector(".flip");
    control_flip.addEventListener('click', function () {
      setTimeout(function () {
        control_flip.nextSibling.nextSibling.classList.toggle('slide_down');
      }, 10)
    })
  }
  if (document.getElementsByClassName("flip2").length > 0) {
    var control_flip2 = document.querySelector(".flip2");
    control_flip2.addEventListener('click', function () {
      setTimeout(function () {
        control_flip2.nextSibling.nextSibling.classList.toggle('slide_down'); 
      }, 10)
    }) 
  }
  // *.*.*.*.*.*.*.*.*.*.* END OF archive toggle *.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*.*
document.querySelectorAll(".show_icon").forEach((element) => {
  element.addEventListener("click", function () {
    const target = this.nextElementSibling;

    if (!target) return;

    const display = window.getComputedStyle(target).display;

    if (display === "none") {
      target.style.display = "block";
    } else {
      target.style.display = "none";
    }
  });
});

})